@for (agenda of agendas; track agenda; let i = $index) {
  <div>
    @if (showDateHeader(i)) {
      <div class="date-representation text-bold-3">
        {{ getDateRepresentation(agenda) }}
      </div>
    }
    <div class="agenda" (click)="agendaClicked(agenda)">
      <div class="planned-date text-bold-3" [ngClass]="{ 'overdue': isPlannedDateOverdue(agenda) }">
        {{ agenda.plannedDate | customDate: 'shortTime' }}
      </div>
      <icon type="phone" class="type-icon" />
      <div>
        <div class="company-name">
          {{ agenda.taskflow?.company?.name }}
          <div class="type-name text-5">{{ getType(agenda) }}</div>
        </div>
      </div>
    </div>
  </div>
}

@if (agendas.length == 0) {
  <div class="no-agendas">
    <div>{{ 'agendas.no-agenda' | translate }}</div>
  </div>
}
